/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputAdminTeam
 */
export interface InputAdminTeam {
    /**
     * 
     * @type {boolean}
     * @memberof InputAdminTeam
     */
    allowBomberMissions?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InputAdminTeam
     */
    allowOpticMissions?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InputAdminTeam
     */
    allowRadioMissions?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InputAdminTeam
     */
    comment?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InputAdminTeam
     */
    craftNames: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof InputAdminTeam
     */
    division?: number;
    /**
     * 
     * @type {string}
     * @memberof InputAdminTeam
     */
    droneUid?: string;
    /**
     * 
     * @type {number}
     * @memberof InputAdminTeam
     */
    flightTimeoutMinutes?: number;
    /**
     * Kind — напрямок екіпажу (fpv|uav). Порожньо трактується як fpv: усі наявні клієнти
     * поля не шлють, і їхні екіпажі мають лишатись тим, чим були.
     * @type {string}
     * @memberof InputAdminTeam
     */
    kind?: InputAdminTeamKindEnum;
    /**
     * 
     * @type {string}
     * @memberof InputAdminTeam
     */
    name: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof InputAdminTeam
     */
    zones?: Array<number>;
}


/**
 * @export
 */
export const InputAdminTeamKindEnum = {
    Fpv: 'fpv',
    Uav: 'uav'
} as const;
export type InputAdminTeamKindEnum = typeof InputAdminTeamKindEnum[keyof typeof InputAdminTeamKindEnum];


/**
 * Check if a given object implements the InputAdminTeam interface.
 */
export function instanceOfInputAdminTeam(value: object): boolean {
    if (!('craftNames' in value)) return false;
    if (!('name' in value)) return false;
    return true;
}

export function InputAdminTeamFromJSON(json: any): InputAdminTeam {
    return InputAdminTeamFromJSONTyped(json, false);
}

export function InputAdminTeamFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminTeam {
    if (json == null) {
        return json;
    }
    return {
        
        'allowBomberMissions': json['allowBomberMissions'] == null ? undefined : json['allowBomberMissions'],
        'allowOpticMissions': json['allowOpticMissions'] == null ? undefined : json['allowOpticMissions'],
        'allowRadioMissions': json['allowRadioMissions'] == null ? undefined : json['allowRadioMissions'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'craftNames': json['craftNames'],
        'division': json['division'] == null ? undefined : json['division'],
        'droneUid': json['droneUid'] == null ? undefined : json['droneUid'],
        'flightTimeoutMinutes': json['flightTimeoutMinutes'] == null ? undefined : json['flightTimeoutMinutes'],
        'kind': json['kind'] == null ? undefined : json['kind'],
        'name': json['name'],
        'zones': json['zones'] == null ? undefined : json['zones'],
    };
}

export function InputAdminTeamToJSON(value?: InputAdminTeam | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'allowBomberMissions': value['allowBomberMissions'],
        'allowOpticMissions': value['allowOpticMissions'],
        'allowRadioMissions': value['allowRadioMissions'],
        'comment': value['comment'],
        'craftNames': value['craftNames'],
        'division': value['division'],
        'droneUid': value['droneUid'],
        'flightTimeoutMinutes': value['flightTimeoutMinutes'],
        'kind': value['kind'],
        'name': value['name'],
        'zones': value['zones'],
    };
}

